var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoonDisplaysleep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9555 12C22.9324 12 14 20.9745 14 32.0407C14 43.1069 22.9324 52.0814 33.9555 52.0814C39.6245 52.0814 44.7297 49.6964 48.3602 45.8869L49 45.2155L48.0845 45.0671C40.4826 43.8355 34.6696 37.2331 34.6696 29.2476C34.6696 23.1255 38.083 17.8087 43.1032 15.1033L43.9168 14.6649L43.0964 14.2392C40.3576 12.8179 37.2536 12 33.9555 12ZM17.7581 32.0408C17.7581 23.0677 25.0262 15.7708 33.9551 15.7708C34.6619 15.7708 35.3611 15.816 36.0509 15.9064C32.7912 19.4978 30.9106 24.2273 30.9106 29.2477C30.9106 36.693 34.9626 43.2419 41.1468 46.6217C38.9423 47.7274 36.4974 48.3108 33.9551 48.3108C25.0262 48.3108 17.7581 41.0139 17.7581 32.0408Z",
    fill: "#C9C9D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonDisplaysleep);
export default __webpack_public_path__ + "static/media/moon_displaysleep.1368d5de688722fc0d5690dcf9bbf4dd.svg";
export { ForwardRef as ReactComponent };